import React from 'react';
import { useTranslation } from '../i18n';

export default function FullScreenImageModal({ images, currentIndex, onClose, onNext, onPrevious }) {
  const { t } = useTranslation();
  if (!images || images.length === 0) return null;

  const image = images[currentIndex];
  const imageUrl = typeof image === 'string' ? image : image.url;
  const imageTitle = typeof image === 'string' ? '' : (image.title || image.description || '');
  const hasMultipleImages = images.length > 1;

  return (
    <div className="fullscreen-modal" onClick={onClose}>
      <img
        src={imageUrl}
        alt={t('modal.fullScreen')}
        className="fullscreen-image"
        onClick={(e) => e.stopPropagation()}
      />
      {imageTitle && (
        <div className="fullscreen-title" onClick={(e) => e.stopPropagation()}>
          {imageTitle}
        </div>
      )}
      {hasMultipleImages && (
        <button
          className="modal-nav-button modal-nav-previous"
          onClick={(e) => {
            e.stopPropagation();
            onPrevious();
          }}
        >
          ‹
        </button>
      )}
      {hasMultipleImages && (
        <button
          className="modal-nav-button modal-nav-next"
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
        >
          ›
        </button>
      )}
      {hasMultipleImages && (
        <div className="modal-counter">
          {currentIndex + 1} / {images.length}
        </div>
      )}
      <button
        className="modal-close-button"
        onClick={onClose}
      >
        ×
      </button>
    </div>
  );
}
